import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import type { EntitlementData } from '../../../master-data/types/entitlement.types.ts';

export const EntitlementSchema = defineSchema({
  name: 'serverEntitlements',
  fields: [
    ['type', 'string'],
    ['value', 'number'],
  ],
  lookupKeys: ['type'], // slot 0 = 시드 row key
});

export interface RawEntitlementRow {
  type: string;
  // Supabase NUMERIC 컬럼은 드라이버에 따라 string 으로 역직렬화될 수 있어 둘 다 허용.
  value?: number | string | null;
}

/** UNLOCK 행은 value 를 비워두거나 null 로 둔다(코드가 무시) — undefined 로 정규화.
 *  MULTIPLIER 의 value 는 NUMERIC→string 가능성을 Number() 로 흡수. */
export function entitlementFromRaw(row: RawEntitlementRow): EntitlementData {
  return {
    type: row.type as EntitlementData['type'],
    value: row.value == null ? undefined : Number(row.value),
  };
}

registerCategorySchema('serverEntitlements', EntitlementSchema);
